<template>
    <div style="height: 100%">
        <div style="text-align: right">
            <div class="print-button" @click="onPrint()">
                <Icon type="md-print" style="color:#044aa1;margin-right: 3px;"/>
                <span>打印</span>
            </div>
            <div class="print-button" @click="onClose()">
                <Icon type="md-close" style="color:#044aa1;margin-right: 3px;"/>
                <span>关闭</span>
            </div>
        </div>
        <div style="width: 60%;margin: 0 auto;padding-bottom: 20px">
            <div id="manual-print-content">
                <div class="row-line"></div>
                <Row class="item-row">
                    <Col span="24">
                        <span>承修方：</span>
                        <span>{{ storeName }}</span>
                    </Col>
                </Row>
                <Row class="item-row">
                    <Col span="16">
                        <span>地址：</span>
                        <span>{{ storeAddress }}</span>
                    </Col>
                    <Col span="8">
                        <span>电话：</span>
                        <span>{{ storeContactsPhone }}</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row">
                    <Col span="8">
                        <span>托修方：</span>
                        <span>{{ orderInfo.memberName }}</span>
                    </Col>
                    <Col span="8">
                        <span>联系电话：</span>
                        <span>{{ memberInfo.phone }}</span>
                    </Col>
                    <Col span="8">
                        <span>车牌号：</span>
                        <span>{{ orderInfo.carPlateNumber }}</span>
                    </Col>
                </Row>
                <Row class="item-row">
                    <Col span="8">
                        <span>工单号：</span>
                        <span>{{ orderInfo.orderNumber }}</span>
                    </Col>
                    <Col span="8">
                        <span>进厂日期：</span>
                        <span>{{ orderInfo.receiveDate }}</span>
                    </Col>
                    <Col span="8">
                        <span>进厂里程：</span>
                        <span>{{ orderInfo.entryMileage }}</span>
                        <span v-if="orderInfo.entryMileage">公里</span>
                    </Col>
                </Row>
                <Row class="item-row">
                    <Col span="8">
                        <span>出厂里程：</span>
                        <span>{{ orderInfo.exitMileage }}</span>
                        <span v-if="orderInfo.exitMileage">公里</span>
                    </Col>
                    <Col span="8">
                        <span>结算日期：</span>
                        <span>{{ orderInfo.settleTime }}</span>
                    </Col>
                    <Col span="8">
                        <span>收银日期：</span>
                        <span>{{ orderInfo.cashierTime }}</span>
                    </Col>
                </Row>
                <Row class="item-row">
                    <Col span="8">
                        <span>车辆类型：</span>
                        <span>{{ carInfo.carTypeName }}</span>
                    </Col>
                    <Col span="16">
                        <span>车型：</span>
                        <span class="car-brand">{{ carInfo.carBrand }}</span>
                        <span class="car-brand">{{ carInfo.carSeries }}</span>
                        <span class="car-brand">{{ carInfo.displacement }}</span>
                        <span class="car-brand">{{ carInfo.productYear }}</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row">
                    <Col span="24">
                        <span class="item-title">一、工时费</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row item-center">
                    <Col span="2">
                        <span>序号</span>
                    </Col>
                    <Col span="3">
                        <span>项目编号</span>
                    </Col>
                    <Col span="5">
                        <span>项目名称</span>
                    </Col>
                    <Col span="3">
                        <span>工时</span>
                    </Col>
                    <Col span="4">
                        <span>工时单价</span>
                    </Col>
                    <Col span="3">
                        <span>项目数量</span>
                    </Col>
                    <Col span="4">
                        <span>金额</span>
                    </Col>
                </Row>
                <Row class="item-row item-center" v-for="(item, index) in itemList" :key="index">
                    <Col span="2">
                        <span>{{ index + 1 }}</span>
                    </Col>
                    <Col span="3">
                        <span>{{ item.code }}</span>
                    </Col>
                    <Col span="5">
                        <span>{{ item.name }}</span>
                    </Col>
                    <Col span="3">
                        <span>{{ item.preManhour }}</span>
                    </Col>
                    <Col span="4">
                        <span>{{ item.unitPrice }}</span>
                    </Col>
                    <Col span="3">
                        <span>{{ item.count }}</span>
                    </Col>
                    <Col span="4">
                        <span>{{ item.totalPrice }}</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row item-center">
                    <Col span="2">
                        <span>合计</span>
                    </Col>
                    <Col span="3">
                        <span></span>
                    </Col>
                    <Col span="5">
                        <span></span>
                    </Col>
                    <Col span="3">
                        <span>{{ getManHourTotal() }}</span>
                    </Col>
                    <Col span="4">
                        <span></span>
                    </Col>
                    <Col span="3">
                        <span>{{ getItemTotalCount() }}</span>
                    </Col>
                    <Col span="4">
                        <span>{{ orderInfo.workPrice }}</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row">
                    <Col span="24">
                        <span class="item-title">二、材料费</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row item-center">
                    <Col span="2">
                        <span>序号</span>
                    </Col>
                    <Col span="6">
                        <span>材料名称</span>
                    </Col>
                    <Col span="4">
                        <span>数量</span>
                    </Col>
                    <Col span="4">
                        <span>单位</span>
                    </Col>
                    <Col span="4">
                        <span>单价</span>
                    </Col>
                    <Col span="4">
                        <span>金额</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row item-center" v-for="(mater, index) in materList" :key="index">
                    <Col span="2">
                        <span>{{ index + 1 }}</span>
                    </Col>
                    <Col span="6">
                        <span>{{ mater.name }}</span>
                    </Col>
                    <Col span="4">
                        <span>{{ mater.count }}</span>
                    </Col>
                    <Col span="4">
                        <span>{{ mater.unitName }}</span>
                    </Col>
                    <Col span="4">
                        <span>{{ mater.actualSellPrice }}</span>
                    </Col>
                    <Col span="4">
                        <span>{{ getItemMaterTotalPrice(mater) }}</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row item-center">
                    <Col span="2">
                        <span>合计</span>
                    </Col>
                    <Col span="6">
                        <span></span>
                    </Col>
                    <Col span="4">
                        <span>{{ getMaterTotalCount() }}</span>
                    </Col>
                    <Col span="4">
                        <span></span>
                    </Col>
                    <Col span="4">
                        <span></span>
                    </Col>
                    <Col span="4">
                        <span>{{ orderInfo.materPrice }}</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row">
                    <Col span="24">
                        <span class="item-title">三、结算价格（单位：元）</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row item-center">
                    <Col span="3">
                        <span>序号</span>
                    </Col>
                    <Col span="9">
                        <span>名称</span>
                    </Col>
                    <Col span="4">
                        <span>金额</span>
                    </Col>
                    <Col span="4">
                        <span>折扣</span>
                    </Col>
                    <Col span="4">
                        <span>实付金额</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row item-center">
                    <Col span="3">
                        <span>1</span>
                    </Col>
                    <Col span="9">
                        <span>工时费</span>
                    </Col>
                    <Col span="4">
                        <span>{{ orderInfo.workPrice }}</span>
                    </Col>
                    <Col span="4">
                        <span>{{ orderInfo.discountWork }}%</span>
                    </Col>
                    <Col span="4">
                        <span>{{ orderInfo.discountWorkPrice }}</span>
                    </Col>
                </Row>
                <Row class="item-row item-center">
                    <Col span="3">
                        <span>2</span>
                    </Col>
                    <Col span="9">
                        <span>材料费</span>
                    </Col>
                    <Col span="4">
                        <span>{{ orderInfo.materPrice }}</span>
                    </Col>
                    <Col span="4">
                        <span>{{ orderInfo.discountMater }}%</span>
                    </Col>
                    <Col span="4">
                        <span>{{ orderInfo.discountMaterPrice }}</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row item-center">
                    <Col span="3">
                        <span>合计</span>
                    </Col>
                    <Col span="9">
                        <span></span>
                    </Col>
                    <Col span="4">
                        <span>{{ orderInfo.totalPrice }}</span>
                    </Col>
                    <Col span="4">
                        <span></span>
                    </Col>
                    <Col span="4">
                        <span>{{ orderInfo.receivablePrice }}</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row class="item-row">
                    <Col span="24">
                        <span class="item-title">四、质量保证期</span>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
                <Row>
                    <Col span="24">
                        <div style="white-space: pre-line">
                            {{ this.storePromise }}
                        </div>
                    </Col>
                </Row>
                <div class="row-line" style="margin-top: 5px"></div>
            </div>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import printJS from 'print-js'
import {queryOrderDetail} from "@/api/business"
import Decimal from "decimal.js"
import {queryStoreSettingOne} from "@/api/baseData"

export default {
    name: "OrderPrint",
    props: {
        orderInput: {
            type: Object,
        },
    },
    data() {
        return {
            orderInfo: {},
            carInfo: {},
            memberInfo: {},
            itemList: [],
            materList: [],
            receivePrice: [],
            merchantName: '',
            storeName: '',
            storeContactsPhone: '',
            storeAddress: '',
            storePromise: '',
            merchantInfo: {},
            storeInfo: {},
        }
    },
    mounted() {
        this.initInfo()
        this.merchantInfo = JSON.parse(sessionStorage.getItem('merchantInfo'))
        this.storeInfo = JSON.parse(sessionStorage.getItem('storeInfo'))
        this.merchantName = this.merchantInfo.name
        this.storeName = this.storeInfo.name
        let temp = this.storeInfo.contactsPhone
        if (temp) {
            this.storeContactsPhone = temp
        }
        temp = this.storeInfo.address
        this.storeAddress = temp
    },
    methods: {
        initInfo() {
            this.receivePrice = []
            queryOrderDetail(this.orderInput).then((res) => {
                this.orderInfo = res.data.workOrder
                this.carInfo = res.data.carInfo
                this.memberInfo = res.data.memberInfo
                this.itemList = res.data.itemInfoList
                for (let item of this.itemList) {
                    this.materList.push(...item.materialsInfoList)
                }
                let wechat = {
                    type: '微信支付',
                    price: this.orderInfo.wechatPrice,
                }
                this.receivePrice.push(wechat)

                let alipay = {
                    type: '支付宝支付',
                    price: this.orderInfo.alipayPrice,
                }
                this.receivePrice.push(alipay)

                let cash = {
                    type: '现金支付',
                    price: this.orderInfo.cashPrice,
                }
                this.receivePrice.push(cash)

                let card = {
                    type: '刷卡支付',
                    price: this.orderInfo.cardPrice,
                }
                this.receivePrice.push(card)

                let balance = {
                    type: '余额扣除',
                    price: this.orderInfo.balancePrice,
                }
                this.receivePrice.push(balance)

                let credit = {
                    type: '挂账',
                    price: this.orderInfo.creditPrice,
                }
                this.receivePrice.push(credit)
            })
            queryStoreSettingOne({type: 1}).then((res) => {
                if (res.data) {
                    this.storePromise = res.data.content
                }
            })
        },
        onClose() {
            this.$emit('handleClose', false)
        },
        onPrint() {
            printJS({
                printable: 'manual-print-content',
                type: 'html',
                header: '',
                targetStyles: ['*'],
                style: `
                    @page {
                      size: auto;
                      margin: 0 1cm 0 1cm;
                      padding: 1cm 0 1cm 0;
                    }
                    @media print {
                      body {
                        margin: 0;
                      }
                    }
                  `,
            })
        },
        getManHourTotal() {
            let mHour = 0
            for (let item of this.itemList) {
                if (item.priceMethod === 1) {
                    mHour += item.preManhour
                }
            }
            return mHour
        },
        getItemTotalCount() {
            let count = 0
            for (let item of this.itemList) {
                count += item.count
            }
            return count
        },
        getItemMaterTotalPrice(mater) {
            return new Decimal(mater.actualSellPrice).mul(mater.count)
        },
        getMaterTotalCount() {
            let count = 0
            for (let mater of this.materList) {
                count += mater.count
            }
            return count
        },
    },
}
</script>

<style scoped>
.print-button {
    display: inline-block;
    border: 1px solid #bbbbbb;
    padding: 3px 10px;
    cursor: pointer;
    margin-right: 10px;
}

#manual-print-content {
    color: #000000;
    font-size: 14px;
    font-weight: normal;
}

.row-line {
    border-top: 1px solid #000000;
}

.item-row {
    padding-top: 8px;
}

.car-brand {
    margin-right: 5px;
}

.item-title {
    font-weight: bold;
}

.item-center {
    text-align: center;
}
</style>
